/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CreateUserPdfInput,
  UserPdf
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create UserPdf
 */
export const createUserPdf = (
    createUserPdfInput: MaybeRefOrGetter<CreateUserPdfInput>,
 signal?: AbortSignal
) => {
      createUserPdfInput = toValue(createUserPdfInput);

      return axiosClient<UserPdf>(
      {url: `/user_pdfs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserPdfInput, signal
    },
      );
    }




export const getCreateUserPdfMutationKey = () => ['createUserPdf'] as const;

export const getCreateUserPdfMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserPdf>>, TError,CreateUserPdfMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUserPdf>>, TError,CreateUserPdfMutationVariables, TContext> => {

const mutationKey = getCreateUserPdfMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserPdf>>, CreateUserPdfMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createUserPdf(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserPdfMutationResult = NonNullable<Awaited<ReturnType<typeof createUserPdf>>>
    export type CreateUserPdfMutationBody = CreateUserPdfInput
    export type CreateUserPdfMutationError = ErrorType<void>
    export type CreateUserPdfMutationVariables = {data: CreateUserPdfInput}

    /**
 * @summary Create UserPdf
 */
export const useCreateUserPdf = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserPdf>>, TError,CreateUserPdfMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createUserPdf>>,
        TError,
        CreateUserPdfMutationVariables,
        TContext
      > => {
      return useMutation(getCreateUserPdfMutationOptions(options), queryClient);
    }
